import { FC, useMemo } from 'react';

import classes from './TaskSpotCard.module.scss';

interface SortKeyBadgeProps {
  sortKey: string | number;
}

const SortKeyBadge: FC<SortKeyBadgeProps> = ({ sortKey }) => {
  const badgeStyle = useMemo(() => {
    const numValue = typeof sortKey === 'string' ? parseInt(sortKey, 10) : sortKey;

    if (numValue <= 50) {
      return { backgroundColor: '#2c2c2c', color: '#ffffff' }; // 가장 어두운 색상
    } else if (numValue <= 100) {
      return { backgroundColor: '#4d4d4d', color: '#ffffff' }; // 중간 어두운 색상
    } else if (numValue <= 150) {
      return { backgroundColor: '#7a7a7a', color: '#ffffff' }; // 중간 밝은 색상
    } else {
      return { backgroundColor: '#a6a6a6', color: '#000000', fontWeight: 'bold' }; // 가장 밝은 색상
    }
  }, [sortKey]);

  return (
    <div className={classes.sortKeyBadge} style={badgeStyle}>
      {sortKey}
    </div>
  );
};

export default SortKeyBadge;
